import * as types from './actionTypes';
import {
  dataSuccess, dataError
} from './actions';
import { ofType } from 'redux-observable';
import { switchMap, map, debounceTime, catchError } from 'rxjs/operators'
import http from '../../../utils/http';
import { fromPromise } from "rxjs/internal-compatibility";
import { of } from 'rxjs'

export const dataEpic = (actions$, state$) => {
  return actions$.pipe(
    ofType(types.DATA_REQUEST),
    debounceTime(300),
    switchMap(action => {
      const {data, onSuccess} = action.payload.toJS();
      return fromPromise(http.post('/user/operation/types', data)).pipe(
        map(response => {
          onSuccess && onSuccess();
          return dataSuccess(response.data.data)
        }),
        catchError(err => {
          return of(dataError())
        }))
    }),
  )
};
